import { temAcesso } from '@/shared/auth/temAcesso'

const SolicitacoesAditivos = () => import('./SolicitacoesAditivos.vue')
// const AtualizacaoCadastralDetalhar = () =>
//     import('./AtualizacaoCadastralDetalhar.vue')

export default {
    path: 'solicitacoesaditivos',
    name: 'Gestores_SolicitacoesAditivos',
    component: SolicitacoesAditivos,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CRED-GEST-ADIT-00')) {
            next()
        }
    }
}
